import React from 'react'
import PropTypes from 'prop-types'

//styles
import './typography.style.scss'

import { useTheme } from 'src/components/ThemeContext'

const Typography = React.memo((props) => {
  const {
    children,
    variant,
    color,
    type = 'regular',
    isRequired,
    isRequiredRed,
    classNames = '',
    labelType,
    parentClassName = '',
    id = '',
    onClick,
    isItalic,
    isDisabled,
    name,
  } = props
  const { mode } = useTheme()

  const themeColor = mode === 'dark' ? 'white' : 'dark'
  const labelTypeClass = labelType ? `typography__label-type--${labelType}` : ''

  return (
    <span className={parentClassName} onClick={onClick} id={id + '-wrapper'} name={name}>
      <span
        className={`typography typography__variant--${variant} typography__type--${type} typography__color__${mode}--${
          isDisabled ? 'disabled' : color ?? themeColor
        } ${labelTypeClass} ${classNames} ${isItalic ? 'italic' : ''}`}
        id={id}
        name={name}
      >
        {children}
        {isRequired && <span className={isRequiredRed ? 'typography__required' : ''}> *</span>}
      </span>
    </span>
  )
})

Typography.displayName = 'Typography'

Typography.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.string,
  color: PropTypes.string,
  type: PropTypes.string,
  isRequired: PropTypes.bool,
  isRequiredRed: PropTypes.bool,
  classNames: PropTypes.string,
  labelType: PropTypes.string,
  parentClassName: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  isItalic: PropTypes.bool,
  isDisabled: PropTypes.bool,
  name: PropTypes.string,
}

Typography.defaultProps = {
  onClick: () => {},
  isRequiredRed: true,
  isItalic: false,
  isDisabled: false,
  variant: 'p1',
  type: 'regular',
  classNames: '',
  name: '',
}

export default Typography
